import React, {Fragment, useContext, useEffect, useState} from 'react';
import {
    Button, Snackbar,
    Typography,
} from '@material-ui/core';
import {Formik, Form} from 'formik';

import InformacionForm from './Forms/InformacionForm';
import CoberturasForm from './Forms/CoberturasForm';

import validationSchema from './FormModel/validationSchema';
import formModel from './FormModel/formModel';
import formInitialValues from './FormModel/formInitialValues';

import useStyles from './styles';

import CotizacionSuccess from "./CotizacionSuccess";
import EmisionSuccess from "./EmisionSuccess";
import Loading from "../../../../Loading";
import axios from 'axios';

import ProgressBar from "../../../../customer/ProductsCustomer/ProgressBar";
import ProgressbarMobile from "../../../../customer/ProductsCustomer/Mobile/ProgressBarMobile";
import white_microseg_icon from '../../../../../assets/images/white_microseg_icon.png';
import PolizaForm from "./Forms/PolizaForm";
import SolicitudForm from './Forms/SolicitudForm';
import ClienteForm from './Forms/ClienteForm';
import CoberturasFormMobile from './FormMobile/CoberturasFormMobile';
import SolicitudFormMobile from './FormMobile/SolicitudFormMobile';
import AffinityContext from "../../../../../context/AffinityContext";
import {Alert} from "@material-ui/lab";
import moment from "moment";
import {formatPhoneNumberIntl} from "react-phone-number-input";

const steps = ['Información', 'Coberturas', 'Resumen', 'Cliente', 'Póliza', 'Solicitud'];
const {formId, formField} = formModel;


function _renderStepContent(step, isMobile, localidades, cotizacionResponse, finalValues) {
    switch (step) {
        case 0:
            return (<InformacionForm formField={formField} localidadesData={localidades}/>);
        case 1:
            return (isMobile
                ? <CoberturasFormMobile formField={formField} isFirstQuotation={finalValues === null}/>
                : <CoberturasForm formField={formField} isFirstQuotation={finalValues === null}/>);
        case 2:
            return <>
                {(cotizacionResponse !== null && finalValues !== null)
                    ?
                    <CotizacionSuccess finalValues={finalValues}
                                       cotizacionResponse={cotizacionResponse} isMobile={isMobile}/>
                    : (
                        <Fragment>
                            <Typography variant="h5" gutterBottom style={{fontFamily: 'EncodeSansBold'}}>
                                Cotizando. Por favor espere...
                            </Typography>
                            <Loading/>
                        </Fragment>
                    )
                }
            </>
        case 3:
            return (<ClienteForm formField={formField}
                               localidadesData={localidades}/>);
        case 4:
            return (<PolizaForm formField={formField}/>);
        case 5:
            return (isMobile
                ? <SolicitudFormMobile formField={formField} cotResponse={cotizacionResponse}/>
                : <SolicitudForm formField={formField} cotResponse={cotizacionResponse}/>);
        default:
            return <div>Not Found</div>;
    }
}

export default function CheckoutPage(props) {
    const {recotizar, idCotizacion, isMobile, scrollIntoView} = props;
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(recotizar === true ? steps.length : 0);
    const currentValidationSchema = validationSchema[activeStep];
    const [preCotizacionResponse, setPreCotizacionResponse] = useState(null);
    const [cotizacionResponse, setCotizacionResponse] = useState(null);
    const [emisionResponse, setEmisionResponse] = useState(null);
    const [finalValues, setFinalValues] = useState(null);
    const {
        localidades,
        affinityId,
        coberturasInfo
    } = useContext(AffinityContext);
    const [localidadesMap, setLocalidadesMap] = useState(null)
    const [openAlert, setOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);


    const handleOpenAlert = (message) => {
        setOpenAlert(true);
        setAlertMessage(message);
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
        setAlertMessage(null);
    };

    async function _preCotizarForm(values, actions) {

        let url = process.env.REACT_APP_BACK_SERVER + '/precotizar/cliente';

        let valuesPrecotizacion = {
            "origen": "affinity",
            "afinidad": affinityId,
            "operacionCliente": true,
            "Nombre": values.nombre,
            "Apellido": values.apellido,
            "DNI": values.dni,
            "Email": values.email,
            "CodArea": formatPhoneNumberIntl(values.telefono).split(' ')[1],
            "Telefono": `${formatPhoneNumberIntl(values.telefono).split(' ')[2]}${formatPhoneNumberIntl(values.telefono).split(' ')[3]}`,
            "Tipo": "MICROSEGURO"
        }

        if (preCotizacionResponse !== null) {
            valuesPrecotizacion["idCliente"] = preCotizacionResponse.id
            valuesPrecotizacion["is_saved"] = true
        }

        axios.post(url, {...valuesPrecotizacion, ...{saveToDatabase: true}}).then(res => {
            setPreCotizacionResponse(res.data);
            actions.setSubmitting(false);
        }).catch(err => {
            console.log(err);
        });
    }

    async function _cotizarForm(values, actions) {

        let url = process.env.REACT_APP_BACK_SERVER + '/cotizar/combinado';

        if (cotizacionResponse !== null) {
            values.id = cotizacionResponse.idCotizacion
            values.is_saved = true
        }

        let initalCoberturasValues = values.coberturas
        values.origen = 'affinity';
        values.afinidad = affinityId
        values.microseguro = true;
        values.operacionCliente = true;
        values.idCliente = preCotizacionResponse.id
        values.fechaCotizacion = moment().format('YYYY-MM-DD')

        let valuesSend = values;
        let coberturasFinal = [];

        for (let cobertura in values.coberturas) {
            if (values.coberturas[cobertura].selectedCobertura) {
                valuesSend.producto = cobertura
                coberturasFinal.push(
                    {
                        sumaAsegurada: values.coberturas[cobertura].sumaAsegurada,
                        numeroCobertura: cobertura,
                    }
                )
            }
        }

        coberturasFinal.push(
            {
                sumaAsegurada: coberturasInfo['1'].sumaMinima,
                numeroCobertura: '1',
            },
            {
                sumaAsegurada: coberturasInfo['2'].sumaMinima,
                numeroCobertura: '2',
            },
        )

        valuesSend.coberturas = coberturasFinal
        if (cotizacionResponse !== null){
            valuesSend.id = cotizacionResponse.idCotizacion;
            valuesSend.is_saved = true;
        }

        axios.post(url, {...valuesSend, ...{saveToDatabase: true}}).then(res => {
            valuesSend.coberturas = coberturasFinal
            values.coberturas = initalCoberturasValues
            setFinalValues(valuesSend);

            res.data.idCotizacion = res.data.cotizacionId
            setCotizacionResponse(res.data);
            actions.setSubmitting(false);
        }).catch(err => {
            console.log(err);
            actions.setSubmitting(false);
            setActiveStep(2)
            handleOpenAlert("Ha habido un error: " + err)
        });
    }

    async function _emitirForm(values, actions) {

        let url = process.env.REACT_APP_BACK_SERVER + '/emitir/combinado';

        setFinalValues(values);

        values.vigenciaHasta = moment(values.vigenciaHasta, 'YYYY-MM-DD').format('YYYY-MM-DD')
        values.vigenciaDesde = moment(values.vigenciaDesde, 'YYYY-MM-DD').format('YYYY-MM-DD')
        values.clientes = [
            {
                "nombre": values.nombre,
                "apellido": values.apellido,
                "codigoArea": formatPhoneNumberIntl(values.telefono).split(' ')[1],
                "telefono": `${formatPhoneNumberIntl(values.telefono).split(' ')[2]}${formatPhoneNumberIntl(values.telefono).split(' ')[3]}`,
                "email": values.email,
                "codigosLocalidad": values.codigosLocalidad,
                "rol": values.rol,
                "personaJuridica": values.personaJuridica,
                "dni": values.dni.toString(),
                "cuit": values.cuit,
                "fechaNacimiento": moment(values.fechaNacimiento, 'YYYY-MM-DD').format('YYYY-MM-DD'),
                "estadoCivil": values.estadoCivil,
                "sexo": values.sexo,
                "domicilio": values.domicilio,
                "situacionIva": values.situacionIva,
                "categoriaMonotributo": values.categoriaMonotributo,
                "actividadPrincipal": values.actividadPrincipal,
                "lugarNacimiento": values.lugarNacimiento
            }
        ]
        values.premium = cotizacionResponse.premioMensual;
        values.operacionCliente = true

        let coberturasFinal = []

        coberturasFinal.push(
            {
                sumaAsegurada: coberturasInfo['1'].sumaMinima,
                numeroCobertura: '1',
            },
            {
                sumaAsegurada: coberturasInfo['2'].sumaMinima,
                numeroCobertura: '2',
            },
        )

        for (let coberturaAd in values.coberturas) {
            if (values.coberturas[coberturaAd].selectedCobertura)
                coberturasFinal.push({
                    numeroCobertura: coberturaAd,
                    sumaAsegurada: values.coberturas[coberturaAd].sumaAsegurada
                })
        }

        values.coberturas = coberturasFinal;

        let equipoElectronicoValues = []

        values.detalleBicicletas.map(item => {
            if (item.sumaAseguradaBicicletas !== '')
                equipoElectronicoValues.push({
                    descripcion: item.descripcionBicicletas,
                    sumaAsegurada: parseInt(item.sumaAseguradaBicicletas),
                    codigo: item.codigoBicicletas,
                    codigoGrupo: item.codigoGrupoBicicletas
                })
        })

        values.detalleMonopatines.map(item => {
            if (item.sumaAseguradaMonopatines !== '')
                equipoElectronicoValues.push({
                    descripcion: item.descripcionMonopatines,
                    sumaAsegurada: parseInt(item.sumaAseguradaMonopatines),
                    codigo: item.codigoMonopatines,
                    codigoGrupo: item.codigoGrupoMonopatines
                })
        })

        values.detalleEquipoElectronico.map(item => {
            if (item.sumaAseguradaElectronico !== '')
                equipoElectronicoValues.push({
                    descripcion: item.descripcionElectronico,
                    sumaAsegurada: parseInt(item.sumaAseguradaElectronico),
                    codigo: item.codigoElectronico,
                    codigoGrupo: item.codigoGrupoElectronico
                })
        })

        if (equipoElectronicoValues.length !== 0)
            values.equipoElectronico = equipoElectronicoValues

        axios.post(url, {...values, ...{idCotizacion: cotizacionResponse.idCotizacion}}).then(res => {
            // console.log(res.data)
            setEmisionResponse(res.data)
            actions.setSubmitting(false);
        }).catch(err => {
            console.log(err);
            alert('No se pudo completar la operación, vuelva a cargar la página')
        });

    }

    function _handleSubmit(values, actions) {
        scrollIntoView()
        actions.setSubmitting(true);
        if (activeStep === 5) {
            setActiveStep(activeStep + 1);
            _emitirForm(values, actions)
        } else if (activeStep === 1) {
            setActiveStep(activeStep + 1);
            setCotizacionResponse(null)
            _cotizarForm(values, actions);
        } else if (activeStep === 0) {
            setActiveStep(activeStep + 1);
            _preCotizarForm(values, actions);
        } else {
            actions.setTouched({});
            actions.setSubmitting(false);
            setActiveStep(activeStep + 1);
        }
    }

    function _handleBack() {
        setActiveStep(activeStep - 1);
    }

    const componentToShow = (actStep) => {
        let component;
        if (actStep === 6) {
            component = (
                <Fragment>
                    <div style={{margin: "16px"}}>
                        {(emisionResponse !== null && finalValues !== null)
                            ? <EmisionSuccess finalValues={finalValues} emisionResponse={emisionResponse}
                                              idCotizacion={idCotizacion} setEmisionResponse={setEmisionResponse}
                                              setActiveStep={setActiveStep}/>
                            : (
                                <Fragment>
                                    <Typography variant="h5" gutterBottom style={{fontFamily: 'EncodeSansBold'}}>
                                        Procesando el pedido. Por favor espere...
                                    </Typography>
                                    <Loading/>
                                    <Typography variant="body1" gutterBottom align="center">
                                        Esto puede demorar hasta 60 segundos.
                                    </Typography>
                                </Fragment>
                            )
                        }
                    </div>
                </Fragment>
            )
        }

        return component;
    }

    const buttonText = (currentStep) => {
        let text;
        switch (currentStep) {
            case 1:
                text = 'Cotizar';
                break;
            case 2:
                text = 'Contratar';
                break;
            case 5:
                text = 'Confirmar';
                break;
            default:
                text = 'Siguiente';
                break;
        }
        return text;
    }

    useEffect(() => {
        let options = localidades.map(d => ({
            "value": d.CodPostal.toString() + ',' + d.CodSancorLocalidad.toString(),
            "label": '(' + d.CodPostal.toString() + ') ' + d.Localidad
        }));
        setLocalidadesMap(options);
    }, [localidades])


    return (
        <React.Fragment>
            {localidadesMap ?
                <>
                    <div className={isMobile ? classes.formBoxMobile : classes.formBox}>

                        <div className={classes.iconCircle}>
                            <img src={white_microseg_icon} style={{width: "32px", height: "auto"}}/>
                        </div>
                        <div style={{margin: "24px 0px"}}>
                            {isMobile
                                ? <ProgressbarMobile activeStep={activeStep} stepTitles={steps}/>
                                : <ProgressBar activeStep={activeStep} stepTitles={steps}/>}
                        </div>
                        <Fragment>

                            <Formik
                                initialValues={formInitialValues}
                                validationSchema={currentValidationSchema}
                                validateOnBlur={false}
                                onSubmit={_handleSubmit}
                            >
                                {({isSubmitting}) => (
                                    <Form id={formId}>
                                        {componentToShow(activeStep)}
                                        <div style={{
                                            display: activeStep === 6 ? "none" : "block"
                                        }}>
                                            {_renderStepContent(activeStep, isMobile, localidadesMap, cotizacionResponse, finalValues)}
                                        </div>
                                        <div className={classes.buttons} style={{display: activeStep > 5 && "none"}}>
                                            {activeStep !== 0 && (
                                                <Button onClick={_handleBack} className={classes.backButton}
                                                        variant="contained"
                                                        disabled={isSubmitting}>
                                                    Atras
                                                </Button>
                                            )}
                                            <div className={classes.buttons}
                                                 style={{display: activeStep > 5 && "none"}}>
                                                <Button
                                                    disabled={isSubmitting}
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.buttonContained}
                                                >
                                                    {buttonText(activeStep)}
                                                </Button>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>

                        </Fragment>
                        <Snackbar open={openAlert && alertMessage} autoHideDuration={5000} onClose={handleCloseAlert}>
                            <Alert onClose={handleCloseAlert} severity="warning" elevation={6} variant="filled"
                                   classes={{filledWarning: classes.alert}}
                            >
                                {alertMessage}
                            </Alert>
                        </Snackbar>

                    </div>
                </>
                :
                <Loading/>}

        </React.Fragment>
    );
}
